import { vModelDynamic, type Directive, type DirectiveHook, type VNode } from "vue";

type ModelHook = DirectiveHook<HTMLElement, VNode | null, unknown>;

const semAtribuidor = (): void => {};

const garantirAtribuidor: (hook: ModelHook | undefined) => ModelHook = (hook) => (el, binding, vnode, prevVNode) => {
  vnode.props ??= {};
  if (!vnode.props["onUpdate:modelValue"]) {
    vnode.props["onUpdate:modelValue"] = semAtribuidor;
  }
  return hook?.(el, binding, vnode, prevVNode);
};

const modelCompat: Directive<HTMLElement> = {
  deep: true,
  created: garantirAtribuidor(vModelDynamic.created as ModelHook | undefined),
  mounted: garantirAtribuidor(vModelDynamic.mounted as ModelHook | undefined),
  beforeUpdate: garantirAtribuidor(vModelDynamic.beforeUpdate as ModelHook | undefined),
  updated: garantirAtribuidor(vModelDynamic.updated as ModelHook | undefined),
};

export default modelCompat;
